import React, { useEffect } from "react";
import { useRemoteComponent } from "@bookingcom/remote-component";
import { isEmpty } from "lodash";
import useEvents from "../../hooks/useEvents.js";
import useWishlistWidgetTracking from "./useWishlistWidgetTracking.js";
const WishlistWidgetLoaderMobile = () => {
    const { Component, isLoading, error } = useRemoteComponent({
        project: "web-shell",
        service: "header-mfe",
        path: "/Wishlists/WishlistWidgetFlightDetailsMobile",
        type: "capla"
    });
    const { grumble } = useEvents();
    useEffect(() => {
        if (!isLoading && error && !isEmpty(error)) {
            grumble("RC error: WishlistWidget Mobile", { error: error.toString() });
        }
    }, [isLoading, error, grumble]);
    useWishlistWidgetTracking({ component: Component, isLoading, error });
    return React.createElement(Component, null);
};
export default WishlistWidgetLoaderMobile;
